"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsTableEditButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));
var _DialogTitle = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));
var _DialogActions = _interopRequireDefault(require("@mui/material/DialogActions"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _DmsButton = require("../DmsButton/DmsButton");
var _DmsSelect = require("../DmsSelect/DmsSelect");
var _DmsSwitch = require("../DmsSwitch/DmsSwitch");
var _DmsFilePicker = require("../DmsFilePicker/DmsFilePicker");
var _DmsTableButton = require("./DmsTableButton");
var _DmsFetch = require("../DmsFetch/DmsFetch");
var _DmsPermissions = require("../DmsPermissions/DmsPermissions");
var _Edit = _interopRequireDefault(require("@mui/icons-material/Edit"));
var _HttpStatus = require("../../constants/HttpStatus");
var _errors = require("../../service/errors/errors");
var _DmsTokenHook = require("../DmsTokenHook/DmsTokenHook");
var _useGet = require("../../Hooks/useGet");
var _sweetalert = _interopRequireDefault(require("sweetalert2"));
var _DateTimePicker = require("@mui/x-date-pickers/DateTimePicker");
var _LocalizationProvider = require("@mui/x-date-pickers/LocalizationProvider");
var _AdapterDayjs = require("@mui/x-date-pickers/AdapterDayjs");
var _TimeZone = require("../../constants/TimeZone");
var _dayjs = _interopRequireDefault(require("dayjs"));
var _utc = _interopRequireDefault(require("dayjs/plugin/utc"));
const _excluded = ["filter", "sortable"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
_dayjs.default.extend(_utc.default);

/**
 * DmsTableEditButton component provides an edit button for DmsTable.
 * @param {Object} props - Component properties.
 * @param {JSX.Element} [props.button_icon=<EditIcon />] - Icon of the edit button.
 * @param {string} [props.button_label] - Label of the edit button.
 * @param {string} [props.button_text] - Text of the edit button.
 * @param {function} [props.handler] - Function that will be called when the user clicks on the edit button.
 * @param {boolean} [props.needs_authentication] - If the edit request needs authentication or not.
 * @param {Object} props.table - Reference to the table that will be affected by the button.
 * @param {string} [props.title=intl.get("Edit").d("Edit")] - Title of the edit modal.
 * @param {string} [props.url] - URL of the edit request.
 * @param {string} [props.variant="primary"] - Variant of the edit button.
 * @param {string} [props.queryData=null] - Additional query data for the URL.
 * @param {boolean} [props.disabled=false] - Whether the edit button is disabled.
 * @returns {JSX.Element} The DmsTableEditButton component.
 */
const DmsTableEditButton = _ref => {
  var _table$current, _table$current$getHea;
  let {
    button_icon = /*#__PURE__*/_react.default.createElement(_Edit.default, null),
    button_label,
    button_text,
    handler,
    needs_authentication,
    table,
    title = _reactIntlUniversal.default.get("Edit").d("Edit"),
    url,
    variant = "primary",
    queryData = null,
    row,
    header,
    disabled = false
  } = _ref;
  const {
    token
  } = (0, _DmsTokenHook.useToken)();
  const [modalState, setModalState] = (0, _react.useState)(false);
  const [modalData, setModalData] = (0, _react.useState)({});
  const [errorModalState, setErrorModalState] = (0, _react.useState)(false);
  const [errorModalTextData, setErrorModalTextData] = (0, _react.useState)("");
  const {
    data,
    isLoading: isLoadingData
  } = (0, _useGet.useGet)(url, row.pk, token, {
    enabled: !!modalState && !table
  });
  (0, _react.useEffect)(() => {}, []);
  const handleButton = (e, data) => {
    if (data) {
      setModalData(data);
    }
    setModalState(true);
  };
  const handleCancelButton = () => {
    setModalState(false);
  };
  const handleSubmit = async e => {
    e.preventDefault();
    if (handler) {
      handler(modalData);
    } else if (url) {
      if (!needs_authentication && table && table.current) {
        needs_authentication = table.current.needs_authentication;
      }
      let endpoint = url;
      if (!endpoint.endsWith("/")) {
        endpoint += "/";
      }
      if (row.pk) {
        endpoint += row.pk;
      }
      if (queryData) {
        endpoint += "?" + queryData;
      }
      const res = await (0, _DmsFetch.fetchUrl)(endpoint, "PUT", needs_authentication ? token : null, modalData, true, true);
      if (res.status !== _HttpStatus.HTTP_STATUS.OK_200) {
        if (res.data.detail) {
          setErrorModalTextData((0, _errors.getErrorDetail)(res.data.detail));
        } else if (res.data.reason) {
          setErrorModalTextData(res.data.reason);
        } else {
          setErrorModalTextData(_reactIntlUniversal.default.get("Unknownerror").d("Unknown error"));
        }
        setErrorModalState(true);
        return null;
      }
      _sweetalert.default.fire({
        icon: "success",
        title: _reactIntlUniversal.default.get("Success").d("Success")
      });
    }
    setModalState(false);
    if (table && table.current && table.current.updateTable) {
      table.current.updateTable();
    }
  };
  const handleErrorButton = () => {
    setErrorModalState(false);
  };
  const renderControl = item => {
    let key = item.column_name;
    const label = item.label ? item.label : item.column_name;
    let value = modalData[key] || "";
    const placeholder = item.placeholder ? item.placeholder : "";
    const control_type = item.control ? item.control : "text";
    let can_edit = item.can_edit;
    const {
        filter,
        sortable
      } = item,
      selectProps = _objectWithoutProperties(item, _excluded);
    const current_timezone = _TimeZone.TIME_ZONE.UTC;
    if (key === "actions" || key === undefined) {
      return null;
    }
    if (can_edit === false) {
      return null;
    }
    can_edit = true;
    if (item.permissions && !(0, _DmsPermissions.havePermissions)(item.permissions)) {
      return null;
    }
    if (item.edit_permissions && !(0, _DmsPermissions.havePermissions)(item.edit_permissions)) {
      return null;
    }
    if (item.form_column_name) {
      key = item.form_column_name;
    }
    let input = null;
    if (control_type === "folder" || control_type === "file") {
      input = /*#__PURE__*/_react.default.createElement(_DmsFilePicker.DmsFilePicker, {
        id: key,
        value: value,
        onChange: path => {
          setModalData(_objectSpread(_objectSpread({}, modalData), {}, {
            [key]: path
          }));
        },
        isDirectory: control_type === "folder"
      });
    } else if (control_type === "select") {
      input = /*#__PURE__*/_react.default.createElement(_DmsSelect.DmsSelect, _extends({}, selectProps, {
        value: modalData[key] || "",
        multiple: item.properties ? item.properties.multiple : false,
        id: key,
        onChange: value => {
          setModalData(_objectSpread(_objectSpread({}, modalData), {}, {
            [key]: value
          }));
        }
      }));
    } else if (control_type === "switch") {
      const val = value === 1;
      input = /*#__PURE__*/_react.default.createElement(_DmsSwitch.DmsSwitch, {
        name: "render_switch",
        id: key,
        checked: val || false,
        onChange: (event, checked) => {
          setModalData(_objectSpread(_objectSpread({}, modalData), {}, {
            [key]: checked ? 1 : 0
          }));
        }
      });
    } else if (control_type === "datetime") {
      input = /*#__PURE__*/_react.default.createElement(_LocalizationProvider.LocalizationProvider, {
        dateAdapter: _AdapterDayjs.AdapterDayjs
      }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_DateTimePicker.DateTimePicker, {
        format: "DD/MM/YYYY HH:mm",
        value: modalData[key] ? _dayjs.default.utc(modalData[key]) : null,
        ampm: false,
        onChange: newData => {
          setModalData(_objectSpread(_objectSpread({}, modalData), {}, {
            [key]: newData
          }));
        },
        timezone: _TimeZone.TIME_ZONE.UTC,
        renderInput: params => /*#__PURE__*/_react.default.createElement(TextField, _extends({}, params, {
          fullWidth: true
        }))
      }));
    } else if (control_type === "textarea") {
      input = /*#__PURE__*/_react.default.createElement("textarea", {
        value: value,
        className: "form-control",
        onChange: event => {
          setModalData(_objectSpread(_objectSpread({}, modalData), {}, {
            [key]: event.target.value
          }));
        },
        id: key,
        placeholder: placeholder,
        rows: 4
      });
    } else {
      input = /*#__PURE__*/_react.default.createElement("input", {
        type: control_type,
        value: value,
        className: "form-control",
        onChange: event => {
          setModalData(_objectSpread(_objectSpread({}, modalData), {}, {
            [key]: event.target.value
          }));
        },
        id: key,
        placeholder: placeholder
      });
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group",
      key: "".concat(key, "_group")
    }, /*#__PURE__*/_react.default.createElement("label", null, label), input);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DmsTableButton.DmsTableButton, {
    table: table,
    variant: variant,
    text: button_text,
    label: button_label,
    icon: button_icon,
    onClick: handleButton,
    title: _reactIntlUniversal.default.get("Tooltip.Action.Edit").d("Edit")
  }), /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    open: modalState,
    onClose: handleCancelButton,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, null, title), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement("form", null, /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      mt: 1
    }
  }, table !== null && table !== void 0 && (_table$current = table.current) !== null && _table$current !== void 0 && (_table$current$getHea = _table$current.getHeader) !== null && _table$current$getHea !== void 0 && _table$current$getHea.call(_table$current) ? table.current.getHeader().map(item => renderControl(item)) : isLoadingData || !Object.keys(modalData).length > 0 ? /*#__PURE__*/_react.default.createElement("div", null, "Loading...") : header === null || header === void 0 ? void 0 : header.map(item => renderControl(item))))), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "secondary",
    onClick: handleCancelButton,
    text: _reactIntlUniversal.default.get("Cancel").d("Cancel")
  }), /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "primary",
    onClick: handleSubmit,
    text: _reactIntlUniversal.default.get("Update").d("Update")
  }))), /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    open: errorModalState,
    onClose: handleErrorButton,
    maxWidth: "xs",
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, null, _reactIntlUniversal.default.get("Error").d("Error")), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      mt: 1
    }
  }, errorModalTextData)), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "secondary",
    onClick: handleErrorButton,
    text: _reactIntlUniversal.default.get("Ok").d("Ok")
  }))));
};
exports.DmsTableEditButton = DmsTableEditButton;